<template>
    <div class="home-page">
		<Header></Header>
		<div class="content mt100 por">
			<div class="home1 flex-center disflex">
				<router-link :to="{path:'/myAccount'}">
					<div class="info ac">
						<img class="img" src="static/images/accout-img2.png" />
						<div class="fs33">{{$t('name')}}</div>
						<div class="name crfff mt50 ovhidden fs40">{{info.name}}</div>
						<div class="phone crfff mt50 ovhidden fs40" v-if="info.name==''">{{info.mobile}}</div>
						<div class="jifen crfff flex flex-center">
							<img src="static/images/xing.png" />
							<span class="fs33 ml10">{{info.score}}</span>
						</div>
					</div>
				</router-link>
				<div class="ac ml30">
					<div class="settings" style="padding:40px 20px 40px 0px">
						<router-link :to="{path:'/setting'}">
							<i class="icons i-sett"></i>
							<span class="fs33 mt10">{{$t('settings')}}</span>
						</router-link>
					</div>
					<div class="ranking">
						<router-link :to="{path:'/ranking'}">
							<i class="icons i-rank"></i>
							<span class="fs33 mt10">{{$t('Ranking')}}</span>
						</router-link>
					</div>
				</div>
			</div>
			<div class="index-list flex flex-center mt100 w548">
				<router-link :to="{path:'/list'}"><i class="icons i-quest"></i></router-link>
				<span class="fs33"><router-link :to="{path:'/list'}">{{$t('Questions')}}</router-link></span>
			</div>
			<div class="index-list index-list2 flex flex-center mt30 w548">
				<router-link :to="{path:'/contentList'}"><i class="icons i-cont"></i></router-link>
				<span class="fs33"><router-link :to="{path:'/contentList'}">{{$t('Contents')}}</router-link></span>
			</div>
		</div>
		<div class="copyright">{{$t('Copyright')}}</div>
    <div class="modal login-modal" v-if="isShow">
      <div class="modal-bg"></div>
      <div class="modal-content modal-content2">
        <img :src="dataPopup.image" />
        <div class="close ac" @click="getClose">x</div>
      </div>

    </div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			info:{},
			mobile:'',
      isShow:false,
      dataPopup:null
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		localStorage.removeItem('mobile1')
		if(this.$route.query.msisdn){
			let str = this.$route.query.msisdn
			str.replace(/\s+/g, '')
			str.replace(/\s+/g, '+')
			this.mobile = str
			localStorage.setItem('mobile1',this.mobile)
		}
		this.getHome();
		console.log(this.$t('name'))
    this.getItem();
	},
    methods: {
		getItem() {
		    if (!localStorage.getItem('setTime_v1') || (localStorage.getItem('setTime_v1') &&
		        Date.parse(new Date()) - localStorage.getItem('setTime_v1') >= 86400000)) {//86400000 24h
		        localStorage.removeItem('setTime_v1');
		        localStorage.setItem('setTime_v1', Date.parse(new Date()));
		        this.getapiPopup();
		    }
		  },
      getapiPopup(){
        let that = this
        let data = {
          type:'home'
        }
        that.$api.post('/api/popup',data,r =>{
        	that.$parent.returnCode(r,function(){
           // r.data = []
            that.dataPopup = r.data
            console.log(that.dataPopup)
            if(that.dataPopup!==null){
             // that.isShow = true
			  //localStorage.setItem('setTime_v1',Date.now())
            }
        	})
        })

      },
      getClose(){
        this.isShow = false

      },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid')}
			that.$api.post('/user/info',data,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
					//console.log(r);
					localStorage.setItem('token',r.data.token)
					localStorage.setItem('uuid',r.data.uuid)
					localStorage.setItem('mobile',r.data.mobile)
                });

			})
		}
	}
}
</script>
<style>
  .modal-content2{text-align:center;position:absolute;top:50%;left:50%;margin-top:-10px;border-radius:8px;margin-left: -45%;width: 90%;}
  .modal-content2 img{border-radius:20px;width:100%;}
  .close{background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 80px;
    height: 80px;
    font-size: 47px;
    margin: 30px auto 0;
    border-radius: 100px;}
</style>



// WEBPACK FOOTER //
// src/page/index.vue